import { useEffect } from 'react'
import { useDispatch } from 'react-redux'
import { useNetworkState } from './appStateHook';

const useInternet = () => {
    const { online, offline } = useNetworkState();
    const dispatch = useDispatch()

    // Registers event listeners to dispatch online/offline statuses to redux
    useEffect(() => {
        const handleOnline = () => online(dispatch);
        const handleOffline = () => offline(dispatch);

        window.addEventListener("online", handleOnline);
        window.addEventListener("offline", handleOffline);

        return () => {
            window.removeEventListener("online", handleOnline);
            window.removeEventListener("offline", handleOffline);
        }
    }, [dispatch, online, offline]);
}

export default useInternet;